import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Col } from '../../components/Col';
import NewAutoCompleteField from '../../components/NewAutoCompleteField/NewAutoCompleteField';
import {
  contratosInitialState,
  CONTRATOS_FILTER_COOD_COOP,
  CONTRATOS_FILTER_CPF_ASSESSOR,
  CONTRATOS_FILTER_CNPJ_EMPRESA,
  CONTRATOS_FILTER_ID_EMPRESA,
} from '../../pages/Contratos/Fluxos/Contratos';
import { getFormattedCNPJ } from '../../utils/DataFormatUtils';
import {
  loadAssessores,
  loadAssessoresByCoop,
} from '../../store/modules/AssessoresActions';
import {
  loadAllEmpresas,
  loadEmpresaByCnpj,
} from '../../store/modules/EmpresasActions';
import styles from './FiltrosListagemContratoAssessor.scss';
const rootClassName = styles.rootClassName;

const INITIAL_STATE = {
  filters: null,
  emptyAssessores: null,
};

class FiltrosListagemContratoAssessor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...INITIAL_STATE,
      filters: this.props.filters,
      emptyAssessores: {
        cpf: contratosInitialState.filters[CONTRATOS_FILTER_CPF_ASSESSOR],
        nome: this.props.languageValues.todosAssessores,
      },
    };
  }

  UNSAFE_componentWillMount = () => {
    this.loadAssessores();
    this.props.loadAllEmpresas();
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    let needLoadAssessores = false;
    if (
      nextProps.filters[CONTRATOS_FILTER_COOD_COOP] !==
      this.state.filters[CONTRATOS_FILTER_COOD_COOP]
    ) {
      needLoadAssessores = true;
    }
    this.setState(
      {
        filters: { ...nextProps.filters },
      },
      () => {
        if (needLoadAssessores) {
          this.loadAssessores();
        }
      }
    );
  }

  hasCoopSelected = () => {
    return this.props.filters[CONTRATOS_FILTER_COOD_COOP] !==
      contratosInitialState.filters[CONTRATOS_FILTER_COOD_COOP]
      ? true
      : false;
  };

  hasEmpresaSelected = () => {
    return this.props.filters[CONTRATOS_FILTER_CNPJ_EMPRESA] !==
      contratosInitialState.filters[CONTRATOS_FILTER_CNPJ_EMPRESA]
      ? true
      : false;
  };

  loadAssessores = () => {
    if (this.hasCoopSelected()) {
      this.props.loadAssessoresByCoop(
        this.props.filters[CONTRATOS_FILTER_COOD_COOP],
        [],
        false
      );
    } else if (this.hasEmpresaSelected()) {
      this.props.loadEmpresaByCnpj(
        this.props.filters[CONTRATOS_FILTER_CNPJ_EMPRESA]
      );
    } else {
      this.props.loadAssessores(false, []);
    }
  };

  assessoresAreLoading = () => {
    if (this.hasCoopSelected()) {
      return this.props.assessores.loadingListByCoop;
    } else {
      return this.props.assessores.loadingList;
    }
  };

  getAssessoresPlaceholder = () => {
    if (this.assessoresAreLoading()) {
      return this.props.languageValues.carregandoAssessores;
    } else {
      if (this.getAssessores().length > 0) {
        return this.props.languageValues.todosAssessores;
      } else {
        return this.props.languageValues.notFoundAssessores;
      }
    }
  };

  getAssessores = () => {
    let items = [];
    if (this.hasCoopSelected()) {
      items = [...this.props.assessores.listByCoop];
    } else if (this.hasEmpresaSelected()) {
      items = this.props.empresas.empresaByCnpj.assessores
        ? this.props.empresas.empresaByCnpj.assessores
        : [];
    } else {
      items = [...this.props.assessores.list];
    }
    return items && items.length > 0
      ? [{ ...this.state.emptyAssessores }, ...items]
      : items;
  };

  getEmpresa = () => {
    let items = [...this.props.empresas.allList];
    return items;
  };

  render() {
    return (
      <>
        <Col cols={[12, 12, 6, 6, 6]}>
          <NewAutoCompleteField
            className={rootClassName + '-assessor-filter'}
            inputClassName={rootClassName + '-assessor-input-filter'}
            label={this.props.languageValues.cadastroContratoEmpresa}
            placeholder={this.props.languageValues.allEmpresas}
            options={this.getEmpresa().map((item) => {
              return {
                label: `${getFormattedCNPJ(item.cnpjEmpresa)} - ${item.nome}`,
                value: item.id,
                cnpj: item.cnpjEmpresa,
              };
            })}
            value={this.props.filters[CONTRATOS_FILTER_ID_EMPRESA]}
            onChange={(value) => {
              if (
                value &&
                value.value !==
                  this.props.filters[CONTRATOS_FILTER_CNPJ_EMPRESA]
              ) {
                this.props.changeValues({
                  [CONTRATOS_FILTER_CNPJ_EMPRESA]: value.cnpj,
                  [CONTRATOS_FILTER_ID_EMPRESA]: value.value,
                });
                this.props.loadEmpresaByCnpj(value.cnpj);
              } else {
                this.props.changeValues({
                  [CONTRATOS_FILTER_CNPJ_EMPRESA]:
                    contratosInitialState.filters[
                      CONTRATOS_FILTER_CNPJ_EMPRESA
                    ],
                  [CONTRATOS_FILTER_ID_EMPRESA]:
                    contratosInitialState.filters[CONTRATOS_FILTER_ID_EMPRESA],
                });
              }
            }}
            disabled={this.props.loading}
          />
        </Col>
        <Col cols={[12, 12, 6, 6, 6]}>
          <NewAutoCompleteField
            label={this.props.languageValues.assessorPedagogicoLabel}
            className={rootClassName + '-assessor-filter'}
            inputClassName={rootClassName + '-assessor-input-filter'}
            disabled={this.state.searching || this.assessoresAreLoading()}
            placeholder={this.getAssessoresPlaceholder()}
            options={this.getAssessores().map((assessor) => {
              return {
                label: assessor.nome,
                value: assessor.cpf,
              };
            })}
            value={this.props.filters[CONTRATOS_FILTER_CPF_ASSESSOR]}
            onChange={(value) => {
              if (
                value &&
                value.value !==
                  this.props.filters[CONTRATOS_FILTER_CPF_ASSESSOR]
              ) {
                this.props.changeValues({
                  [CONTRATOS_FILTER_CPF_ASSESSOR]: value.value,
                });
              } else {
                this.props.changeValues({
                  [CONTRATOS_FILTER_CPF_ASSESSOR]:
                    contratosInitialState.filters[
                      CONTRATOS_FILTER_CPF_ASSESSOR
                    ],
                });
              }
            }}
            loading={this.props.loading || this.assessoresAreLoading()}
            loadingMessage={this.props.languageValues.carregandoAssessores}
          />
        </Col>
      </>
    );
  }
}

FiltrosListagemContratoAssessor.propTypes = {
  loading: PropTypes.bool,
  filters: PropTypes.object.isRequired,
  changeValues: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  assessores: state.assessores,
  logradouro: state.logradouro,
  contratos: state.contratos,
  empresas: state.empresas,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadAssessoresByCoop,
      loadAssessores,
      loadAllEmpresas,
      loadEmpresaByCnpj,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FiltrosListagemContratoAssessor);
